import useTranslation from 'hooks/useTranslation';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { replaceKeyWithValue } from 'utils/text';
import { CreditBuyIconComponent } from 'assets/icons';

const getIsSideMenuCollapsed = ({ layoutData }) =>
  layoutData.isSideMenuCollapsed;

function PackageExpireAlert({ accountType, remainingDays }) {
  const mode = accountType === 9 ? 'EXPIRED' : 'EXPIRE_SOON';

  const isSideMenuCollapsed = useSelector(getIsSideMenuCollapsed);
  const { getTranslation } = useTranslation('WEBSITES');
  const { t } = getTranslation();

  const DESCRIPTION_ON_MODE = {
    EXPIRED: t('SERVICE_END_DESC'),
    EXPIRE_SOON: replaceKeyWithValue(t('EXPIRE_SOON'), 'days', remainingDays),
  };

  const descriptionText = DESCRIPTION_ON_MODE[mode];

  return (
    <div
      className={styles.package_expire_alert_wrapper}
      data-collapse={isSideMenuCollapsed}
      data-mode={mode}
    >
      <p data-collapse={isSideMenuCollapsed} className={styles.service_end}>
        {t('SERVICE_END')}
      </p>
      <p
        data-collapse={isSideMenuCollapsed}
        className={styles.service_end_desc}
      >
        {descriptionText}
      </p>

      <Link
        data-collapse={isSideMenuCollapsed}
        to='/payment/package-upgrading'
        className={styles.tamdid}
      >
        <span>{t('REVIVE_SERVICE')}</span>

        <CreditBuyIconComponent />
      </Link>
    </div>
  );
}

export default PackageExpireAlert;
